import React from 'react'
import { AsideInfoByStep, FormControlsProps } from './interface'
import { AWS_S3_URL, WIZARD_STAGES_ID } from 'utils/constants'
import { ConfirmationAsideContent } from './components/Confirmation/components'
import { DocumentsAsideContent } from './components/Documents/components'
import { isRequired } from 'utils/validations'
import { LifeTestAsideContent } from './components/LifeTest/components/LifeTestAsideContent/LifeTestAsideContent'
import { TFunction } from 'i18next'

export const FORM_CONTROLS_PROPS = (t: TFunction): FormControlsProps => ({
  companyName: {
    element: 'input',
    name: 'companyName',
    type: 'text',
    validations: [isRequired(t)]
  }
})

export const T_ROOT_ASIDE = 'bluebook.aside'

export const asideInfoByStep = (t: TFunction): AsideInfoByStep => ({
  [WIZARD_STAGES_ID.evaluation]: {
    title: t(`${T_ROOT_ASIDE}.inProcessEvaluation.title`),
    component: <p>{t(`${T_ROOT_ASIDE}.inProcessEvaluation.description`).toString()}</p>,
    image: {
      src: `${AWS_S3_URL}/img/OB_Info_Fiscal.svg`,
      alt: '',
      className: ''
    }
  },
  [WIZARD_STAGES_ID.documents]: {
    title: t(`${T_ROOT_ASIDE}.inProcessProfileDocuments.title`),
    component: DocumentsAsideContent(t),
    image: {
      src: `${AWS_S3_URL}/img/OB_Documentos.svg`,
      alt: '',
      className: ''
    }
  },
  [WIZARD_STAGES_ID.additional]: {
    title: t(`${T_ROOT_ASIDE}.inProcessAdditionalInfo.title`),
    component: <p>{t(`${T_ROOT_ASIDE}.inProcessAdditionalInfo.description`).toString()}</p>,
    image: {
      src: `${AWS_S3_URL}/img/OB_Info_Adicional.svg`,
      alt: '',
      className: ''
    }
  },
  [WIZARD_STAGES_ID.life]: {
    title: t(`${T_ROOT_ASIDE}.inProcessProofOfLife.title`),
    component: LifeTestAsideContent(t),
    image: {
      src: `${AWS_S3_URL}/img/OB_Prueba_de_Vida.svg`,
      alt: '',
      className: ''
    }
  },
  [WIZARD_STAGES_ID.confirmation]: {
    title: t(`${T_ROOT_ASIDE}.confirmation.title`),
    component: ConfirmationAsideContent(t),
    image: {
      src: `${AWS_S3_URL}/img/OB_Confirmacion.svg`,
      alt: '',
      className: ''
    }
  }
})

export const toastOnboardingErrorIcon = `${AWS_S3_URL}/img/icons/Warning.svg`
